import React, { useState } from 'react'
import { useHistory } from 'react-router'
import { connect } from 'react-redux'
import MainHeader from '../ReusableComponents/Header/MainHeader'
import OptionCard from '../ReusableComponents/OptionCard/OptionCard'
import visionIcon from '../../Assets/appModeAi/vision.svg'
import speechIcon from '../../Assets/appModeAi/speech.svg'
import styles from './WebAi.module.css'

const WebAiPlay = () => {
    const history = useHistory()
    const [toast, setToast] = useState('')

    const goBack = () => {
        sessionStorage.setItem('slideDirection', true)
        history.push('/Selection')
    }

    const handleVision = () => {
        history.push('/vision')
    }

    const handleSpeech = () => {
        setToast('Speech is coming soon...')
        setTimeout(() => setToast(''), 2000)
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <MainHeader
                    title="Play"
                    titlePosition="left"
                    isGoBack={true}
                    goBack={goBack}
                    showAccountSetting={true}
                />
            </div>
            <div className={styles.body}>
                <OptionCard
                    icon={visionIcon}
                    label="Vision"
                    onClick={handleVision}
                />
                <OptionCard
                    icon={speechIcon}
                    label="Speech"
                    onClick={handleSpeech}
                    disabled={true}
                />
            </div>
            {toast && <p className="comingSoon_text">{toast}</p>}
        </div>
    )
}

const mapStateToProps = (state) => state
export default connect(mapStateToProps)(WebAiPlay)
